/**
 * Kategoriska färger tilldelas i fast ordning och följer entiteten, aldrig dess
 * rangordning. Ett filter som tar bort en serie får alltså inte måla om de som
 * blir kvar – därför bygger vi en nyckel->slot-karta en gång och behåller den.
 */
export const SERIES_SLOTS = 11;

export const SERIES_VARS = Array.from({ length: SERIES_SLOTS }, (_, i) => `var(--series-${i + 1})`);

export function colorFor(index: number): string {
  return SERIES_VARS[index % SERIES_SLOTS];
}

/**
 * Låser färgtilldelningen till en fast nyckellista. Nycklar bortom antalet
 * slots ska inte få en genererad färg – de viks in i "Övrigt" av anroparen.
 */
export function buildColorMap(keys: string[]): Map<string, string> {
  return new Map(keys.slice(0, SERIES_SLOTS).map((key, index) => [key, colorFor(index)]));
}

export const NEUTRAL_SERIES = 'var(--axis)';
